import type { AppModule } from '@/app/app-module.types';
import { MailIcon } from '@/shared/icons';
import { ADMINISTRATOR } from '@/shared/guards/roles';
import { notifyContainer } from './di/container';
import { NotifyRepositoryToken } from './di/tokens';
import { notifyRoutes } from './presentation/routes';

export const notifyModule: AppModule = {
  name: 'notify',

  register(container) {
    container.register(NotifyRepositoryToken, () => notifyContainer.repository);
  },

  routes: notifyRoutes,

  menu: [
    {
      label: 'E-mails',
      to: '/notify/emails',
      icon: MailIcon,
      section: 'operations',
      order: 4,
      roles: [ADMINISTRATOR],
    },
  ],
};
